import { ContentStat } from "seneca-common/features/stats/state";

export default function lastAttemptIncorrect(
  meta: ContentStat | null | undefined
) {
  return meta && meta.lastScore !== null && meta.lastScore! < 1;
}
